export { InitialAvatar } from './InitialAvatar';
export type { InitialAvatarProps } from './InitialAvatar';
